// Profile API. Methods are bound to the shared ApiClient instance
// via Object.assign in src/utils/api.js.
export function createProfileApi(client) {
  return {
    async getProfile(id) {
      try {
        const result = await this.call(`/profile?id=${id}`)
        return { data: result.data, error: null }
      } catch (error) {
        return { data: null, error: { code: error.code || null, message: error.message } }
      }
    },

    async getProfileByUsername(username) {
      const result = await this.call(`/profile?username=${username}`)
      return { data: result.data, error: null }
    },

    async getHomeData(userId) {
      const result = await this.call(`/discovery?userId=${userId}`)
      return { data: result.data, error: null }
    },

    async getFollowers(userId) {
      const result = await this.call(`/profile?id=${userId}&type=followers`)
      return { data: result.data, error: null }
    },

    async getFollowing(userId) {
      const result = await this.call(`/profile?id=${userId}&type=following`)
      return { data: result.data, error: null }
    },

    async getLeaderboard(metric) {
      const result = await this.call(`/profile?type=leaderboard&metric=${metric}`)
      return { data: result.data, error: null }
    },

    async getWeeklyLeague() {
      const result = await this.call('/profile?type=league')
      return { data: result.data, error: null }
    },

    async createProfile(profile) {
      const result = await this.call('/profile', {
        method: 'POST',
        body: JSON.stringify(profile)
      })
      return { data: result.data, error: null }
    },

    async updateProfile(id, updates) {
      const result = await this.call(`/profile?id=${id}`, {
        method: 'PUT',
        body: JSON.stringify(updates)
      })
      return { data: result.data, error: null }
    },

    async followUser(followerId, targetId) {
      const result = await this.call('/profile', {
        method: 'POST',
        body: JSON.stringify({ action: 'follow', followerId, targetId })
      })
      return { data: result.data, error: null }
    },

    async unfollowUser(followerId, targetId) {
      const result = await this.call('/profile', {
        method: 'POST',
        body: JSON.stringify({ action: 'unfollow', followerId, targetId })
      })
      return { data: result.data, error: null }
    },

    async getResolutions(filters = {}) {
      const params = new URLSearchParams()
      params.append('type', 'resolutions')
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, value)
      })
  
      const result = await this.call(`/profile?${params}`)
      return { data: result.data, error: null }
    },

    async createResolution(resolutionData) {
      const result = await this.call('/profile?type=resolutions', {
        method: 'POST',
        body: JSON.stringify(resolutionData)
      })
      return { data: result.data, error: null }
    },

    async updateResolution(id, updates) {
      const result = await this.call(`/profile?type=resolutions&id=${encodeURIComponent(id)}`, {
        method: 'PUT',
        body: JSON.stringify(updates)
      })
      return { data: result.data, error: null }
    },

    async deleteResolution(id) {
      const result = await this.call(`/profile?type=resolutions&id=${id}`, {
        method: 'DELETE'
      })
      return { error: null }
    }
  }
}
